module.exports = __webpack_public_path__ + "img/hr-deepwater-green-outer-corner.b827dbbc.png";